export default function SpeedTyperIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="38" width="56" height="20" rx="5" fill="#3B434F" />
      <g fill="#E8ECF4">
        <rect x="8" y="42" width="6" height="5" rx="1.2" />
        <rect x="16" y="42" width="6" height="5" rx="1.2" />
        <rect x="24" y="42" width="6" height="5" rx="1.2" />
        <rect x="32" y="42" width="6" height="5" rx="1.2" />
        <rect x="40" y="42" width="6" height="5" rx="1.2" />
        <rect x="48" y="42" width="8" height="5" rx="1.2" />
        <rect x="12" y="49" width="40" height="5" rx="1.2" />
      </g>
      <path d="M2 22h10M4 28h8M6 16h6" stroke="#74B6FF" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M14 30l2-8c1-3 3-5 7-6l10-1c3 0 6 2 8 5l3 2c6 0 10 2 11 5v3z"
        fill="#FF8A1F"
        stroke="#B65A08"
        strokeWidth="1.5"
      />
      <path d="M26 18l9-1c2 0 4 1 5 3l1 2H25z" fill="#BFE6FF" />
      <circle cx="22" cy="31" r="5" fill="#1B1D24" />
      <circle cx="22" cy="31" r="2" fill="#C9CED8" />
      <circle cx="47" cy="31" r="5" fill="#1B1D24" />
      <circle cx="47" cy="31" r="2" fill="#C9CED8" />
    </svg>
  );
}
